import { createTheme, ThemeProvider } from "@mui/material";
import { SnackbarProvider } from "notistack";

import variables from "../assets/js/variables";

const theme = createTheme({
  direction: "rtl",
  palette: {
    primary: {
      main: "#00EEB8",
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          margin: "1rem 9rem",
          borderRadius: "none",
          background: "none",
          boxShadow:
            "0px 11px 15px -7px rgba(0,0,0,0.2), 0px 8px 5px 3px rgba(0,0,0,-5.86), 0px 9px 46px 8px rgba(0,0,0,0.12)",
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        icon: {
          margin: "0 0 0 12px",
        },
        action: {
          margin: "0 auto 0 -8px",
          padding: "2px 14px 0 0",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: "#00EEB8",
          left: "unset",
          right: "2.8em",
          transformOrigin: `top right`,
          fontFamily: "inherit",
          ":hover": {
            color: "#00EEB8",
          },
          ":focus": {
            color: "#00EEB8",
          },
          ":active": {
            color: "#00EEB8",
          },
          ":focus-within": {
            color: "#00EEB8",
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          fontFamily: "inherit",
          borderRadius: "10px",
          "&.Mui-error .MuiOutlinedInput-notchedOutline": {
            borderColor: "#d32f2f !important",
          },
          "&:hover, &.Mui-focused .MuiOutlinedInput-notchedOutline": {
            ".MuiOutlinedInput-notchedOutline": {
              borderColor: `${variables.colors.lightBlue} !important`,
            },
          },
        },
        notchedOutline: {
          border: `solid 2px ${variables.colors.blue} !important`,
          textAlign: "right",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          color: "white",
          background: "rgba(0,0,0, 0.2)",
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontFamily: "inherit",
          textAlign: "right",
          marginTop: "10px",
        },
      },
    },
  },
});

const StyleProvider = ({ children }) => (
  <ThemeProvider theme={theme}>
    <SnackbarProvider maxSnack={3}>{children}</SnackbarProvider>
  </ThemeProvider>
);
export default StyleProvider;
